import { TablesByTagQuery } from '../../../../../../gen-src/queries';
import { getMaxDownstreamDatasources, getMaxDownstreamWorkbooks, MaxCountsResultData } from '../../../../data-catalog-shared';
import { DenormalizedVirtualConnectionTableRowData } from '../types/VirtualConnectionTablesDisplayGridRowData';

export function getRowDataWithMaxCountsForVirtualConnectionTable<T>(
  table: T,
  resultData: MaxCountsResultData | null,
): T & DenormalizedVirtualConnectionTableRowData {
  return {
    ...table,
    contentType: 'virtualConnectionTable',
    maxDownstreamDatasources: getMaxDownstreamDatasources(resultData),
    maxDownstreamWorkbooks: getMaxDownstreamWorkbooks(resultData),
  };
}

export function getRowDataWithMaxCountsForVirtualConnectionTableWithTagFilter<T>(
  table: T,
  resultData: TablesByTagQuery | null,
): T & DenormalizedVirtualConnectionTableRowData {
  const tag = resultData && resultData.tags && resultData.tags[0];
  return getRowDataWithMaxCountsForVirtualConnectionTable(table, tag);
}
